<app-header></app-header>
<div class="container-fluid">
  <h2>Track Hubs Submission</h2  >
  <hr>
  <div fxLayout="row" fxLayout.lt-md="column" style="margin-bottom: 30px;">
    <div fxFlex>
      <button mat-raised-button color="primary">
        <a href="{{trackhubs_template_with_examples}}">Download example template</a>
      </button>

      <button mat-raised-button color="primary">
        <a href="{{trackhubs_template_without_examples}}">Download empty template</a>
      </button>

      <button mat-raised-button color="accent">
        <a href="https://dcc-documentation.readthedocs.io/en/latest/trackhubs/trackhubs_submission/" target="_blank"
           style="color: black;">Submission guidelines</a>
      </button>
    </div>

    @if (token) {
      <button mat-raised-button color="warn" fxFlex="150px" fxFlexAlign="end" (click)="logout()">Logout</button>
    }
  </div>
  @if (!token) {
    <button mat-raised-button color="primary" (click)="openLoginModal()">Login to start submission</button>
  }
  <div fxLayout="column" [hidden]="!token">
    <h3>Upload template</h3>
    <hr>
    <app-bulk-files-uploader
      [uploadUrl]="uploadUrl"
      [mode]="'single'"
      [user]="user">
    </app-bulk-files-uploader>
    <mat-radio-group [(ngModel)]="user['modify']" fxLayout="row" style="margin-bottom: 20px;">
      <mat-radio-button value="false" style="margin-right: 20px;">Submit new trackhub</mat-radio-button>
      <mat-radio-button value="true">Update existing trackhub</mat-radio-button>
    </mat-radio-group>

    @if ((validation_results | json) !== '{}') {
      <div>
        <hr>
        <h3 style="margin: 20px 0;">Validation Results</h3>
        @if (tabHasError('Hub Data') || tabHasError('Genome Data') || tabHasError('Tracks Data')) {
          <ul
            class="alert alert-danger" style="list-style-type:none;">
            @if (tabHasError('Hub Data')) {
              <li>
                Fix errors in "Hub Data" sheet
              </li>
            }
            @if (tabHasError('Genome Data')) {
              <li>
                Fix errors in "Genome Data" sheet
              </li>
            }
            @if (tabHasError('Tracks Data')) {
              <li>
                Fix errors in "Tracks Data" sheet
              </li>
            }
          </ul>
        }
        <mat-tab-group style="margin: 20px 0;">
          @for (tab of tabs; track tab) {
            <mat-tab [label]="tab">
              <div class="table-responsive">
                <table mat-table [dataSource]="validation_results[tab]" table-striped style="width: 100%; margin-top: 15px;">
                  @for (col of columns[tab]; track col) {
                    <ng-container [matColumnDef]="col">
                      <th mat-header-cell class="table-header" *matHeaderCellDef> {{col}} </th>
                      <td mat-cell class="table-cell-data" *matCellDef="let item; let i = index"
                          [ngClass]="getCellClass(tab, i, col)" [ngStyle]="{'cursor': getCellStyle(tab, i, col)}"
                          (click)="showError(tab, i, col)">
                        {{item[col]}}
                      </td>
                    </ng-container>
                  }
                  <tr mat-header-row *matHeaderRowDef="columns[tab]"></tr>
                  <tr mat-row *matRowDef="let row; columns: columns[tab]"></tr>
                </table>
              </div>
            </mat-tab>
          }
        </mat-tab-group>
        @if (validation_results.hasOwnProperty('HubCheck Results')) {
          <div style="margin: 30px 0;">
            <h5>HubCheck Results</h5>
            @if (validation_results['HubCheck Results']['errors'].length) {
              <ul
                class="alert alert-danger" style="margin: 20px 0; list-style-type:none;">
                @for (err of validation_results['HubCheck Results']['errors']; track err) {
                  <li>
                    {{err}}
                  </li>
                }
              </ul>
            }
            @if (validation_results['HubCheck Results']['warnings'].length) {
              <ul
                class="alert alert-warning" style="margin: 20px 0; list-style-type:none;">
                @for (err of validation_results['HubCheck Results']['warnings']; track err) {
                  <li>
                    {{err}}
                  </li>
                }
              </ul>
            }
            <hr>
          </div>
        }
        <h3 style="display: inline; margin: 20px 0;">Submission</h3>
        <mat-icon style="margin-left: 10px;" matTooltipPosition="right"
                  matTooltip="Register your track hub with the Track Hub registry and associate the track hub with related specimen records">
          help_outline
        </mat-icon>
        <div style="margin: 20px 0;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="5%">
          <div fxFlex="48">
            <button mat-raised-button color="primary"
                    style="margin-bottom: 20px;" [disabled]="hasError()"
                    (click)="submitTrackHub()">
              Submit Track Hub
            </button>
          </div>
          <div fxFlex="47">
            @if (registration_success_msg) {
              <div class="alert alert-info">
                {{ registration_success_msg }}
              </div>
            }
            @if (registration_failed_msg) {
              <div class="alert alert-danger">
                {{ registration_failed_msg }}
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>

<ng-template #errorModalTemplate let-data>
  <div mat-dialog-content>
    {{data['error']}}
  </div>
</ng-template>

<!-- Template: Login Modal Dialog Box -->
<ng-template #loginModalTemplate let-data>
  <!-- User Login -->
  <div mat-dialog-content>
    <h3><p>Login</p></h3>
    <mat-form-field appearance="fill" style="width: 100%">
      <mat-label>Enter your username</mat-label>
      <input matInput [(ngModel)]="username">
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill" style="width: 100%">
      <mat-label>Enter your password</mat-label>
      <input matInput [(ngModel)]="password" [type]="hide ? 'password' : 'text'">
      <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>
    @if (error) {
      <p class="alert alert-danger">{{error}}</p>
    }
    <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-top: 10px;">
      <button mat-raised-button color="primary" (click)="login()">
        Submit
      </button>
      <p> If you do not have a Webin account, click
        <a href="https://www.ebi.ac.uk/ena/submit/webin/accountInfo" target="_blank">here</a>
        to register
      </p>
    </div>
  </div>
</ng-template>
